import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import hairBg from '../../assets/hair.svg';
import Image from '../../components/ContentfulImage';
import media from '../../styles/media.style';
import Placeholder from '../../components/Placeholder';
import { BG_GRAY, MOBILE_PADDING, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

const FeaturedSection = styled.section`
  background: center / cover no-repeat url(${hairBg}), ${BG_GRAY.COMMON_1};
  padding: 50px ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    padding: 120px 0;
  `};
`;

const Entry = styled.div`
  margin: auto;
  margin-top: 40px;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    margin-top: 155px;
  `};

  &:first-child {
    margin-top: 0;
  }
`;

const ImageContainer = styled.div`
  width: 100%;

  ${media.tabletL`
    width: 50%;
  `};
`;

const Details = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 25px;

  ${media.tabletL`
    align-items: flex-start;
    margin-top:0;
    padding-left: 125px;
    width: 50%;
  `};
`;

const Title = styled.div`
  font-size: 28px;
  font-weight: 500;
  line-height: 1.14;
  letter-spacing: 0.4px;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    font-size: 38px;
    line-height: 1.21;
    letter-spacing: 0.5px;
    text-align: left;
  `};
`;

const Description = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.29;
  letter-spacing: 0.6px;
  margin-top: 15px;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    font-size: 18px;
    line-height: 1.39;
    letter-spacing: 0.1px;
    margin-top: 35px;
    text-align: left;
  `};
`;

const Button = styled.div`
  align-items: center;
  background-color: black;
  color: white;
  display: flex;
  height: 60px;
  justify-content: center;
  margin-top: 20px;
  width: 220px;

  ${media.tabletL`
    margin-top: 40px;
    width: 280px;
  `};
`;

const Featured = ({ entries, locale, copy }) => {
  const mapEntry = entry => {
    if (entry.contentType === 'inspirationArticle') {
      const btc = entry;
      btc.image = btc.btcThumbnail;
      btc.description = btc.btcShortDescription;
      btc.link = `/${locale}/inspiration/beauty-creators-talk/${entry.slug}`;
      return btc;
    }
    // eslint-disable-next-line no-param-reassign
    entry.link = `/${locale}/news-and-events/${entry.slug}`;
    return entry;
  };

  return (
    <FeaturedSection>
      {entries.map(mapEntry).map(entry => (
        <Entry key={entry.title || entry.key}>
          <ImageContainer>
            {entry.image ? <Image src={entry.image} options={{ size: 550 }} /> : <Placeholder w="100%" pb="72%" />}
          </ImageContainer>
          <Details>
            <Title>{entry.title || <Placeholder h="75px" w="100%" />}</Title>
            <Description>{entry.description || <Placeholder h="75px" w="100%" />}</Description>
            {entry.slug ? (
              <Link to={entry.link} href={entry.link}>
                <Button>{copy.learn_more || <Placeholder h="15px" w="100px" />}</Button>
              </Link>
            ) : (
              <Button>{copy.learn_more || <Placeholder h="15px" w="100px" />}</Button>
            )}
          </Details>
        </Entry>
      ))}
    </FeaturedSection>
  );
};

Featured.defaultProps = {
  entries: [{ key: 1 }, { key: 2 }],
  copy: {},
};

Featured.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape()),
  copy: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(Featured);



// WEBPACK FOOTER //
// ./src/pages/NewsAndEventsPage/FeaturedSection.js